//* Helpers
import { config } from '@/helpers';

//* Components
import Text from '@/components/Text';
import Image from '@/components/Image';
import CustomLink from '@/components/CustomLink';

//* Styles
import ItemServiceStyle from './style';

const ItemService = ({ image, url, title }) => {
	return (
		<ItemServiceStyle>
			<div className='inner-wrapper-item'>
				<CustomLink url={config.routes.service.path + url}>
					<Image
						src={image.src}
						alt={image.alt}
					/>

					<div className='wrapper-description'>
						<Text className={'p2'}>{title}</Text>
					</div>
				</CustomLink>
			</div>
		</ItemServiceStyle>
	);
};

export default ItemService;
